import * as React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import UserTable from "../../components/Tables/UserTable";
import { UserAuth } from "../../context/AuthContext";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import { Link as RouterLink } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

export default function ManageUserPage() {
  const { userData } = UserAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (userData && userData?.role !== "super") {
      navigate("/unauthorized", { replace: true });
    }
  }, [userData, navigate]);

  if (!userData || userData?.role !== "super") {
    return null; // Render nothing if user data is not available or if user is not a super user
  }

  return (
    <DashboardLayout title="Manage User" visible={false} button={
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Button
          component={RouterLink}
          to="/adduser"
          variant="outlined"
          color="primary"
          startDecorator={<AddIcon />}
          size="sm"
        >
          Add User
        </Button>
      </Box>
    }>
      <UserTable />
    </DashboardLayout>
  );
}
